import React from 'react';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import { useModal } from '../../../hooks/useModal';
import Form from '../../baseComponents/gui/form/Form';
import { useUser } from '../../../redux/reducer/user';
import Input from '../../baseComponents/gui/input/Input';
import { addFriend } from '../../../constants/copyright';
import AddFriendForm from './AddFriendForm';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import { useRequestData } from '../../../redux/reducer/requests';
import { getValidationTexts } from '../../../constants/form';
import { useRequestsHandlerData } from '../../../hooks/useRequestsHandlerData';
import AppLoader from '../../features/appLoader/AppLoader';
import { useFormErrors } from '../../../hooks/useFormErrors';
import { useTranslation } from '../../../translations';

const AddFriendModal = React.forwardRef(function AddFriendModal({ callbacks }, ref) {
  const { closeModal } = useModal();
  const { favorites, profile } = useUser();
  const { request: addFriendRequest } = useRequestData('requests/user/add-friend');
  const { form } = addFriend;
  const props = arguments[0];
  const isAdded = false;
  const { t } = useTranslation();
  const slots = { inputs: getInputs() || [] };

  const [errors, addNewError] = useFormErrors();

  const close = () => {
    closeModal({ type: 'all' });
  };

  const onSubmitFriend = ({ friendId }) => {
    const isAdded = favorites?.find((friend) => friend?.uid === friendId);

    const isMyUid = profile?.uid === friendId;

    if (isAdded || isMyUid) {
      addNewError({
        friendId: {
          message: getValidationTexts(t)[isAdded ? 'FRIEND_ADDED' : isMyUid ? 'IS_MY_UID' : 'FALLBACK_ERROR'],
        },
      });
      return;
    }

    callbacks.addFriend(friendId);
  };

  const isPending = useRequestsHandlerData([
    {
      address: 'requestsUserAddFriend',
      fulfilled: close,
      rejected: () => addNewError({ friendId: { message: getValidationTexts(t).REQUIRED_MESSAGE_ID } }),
    },
  ]);

  function getInputs() {
    const inputs = form?.filter((item) => item.input) ?? [];
    return inputs.map(({ input }, inputIndex) => {
      const Component = Input;
      const { rules } = input;
      return (
        <Component
          key={'FormInput-' + inputIndex}
          {...input}
          placeholder={input.placeholder}
          rules={rules(t)}
          Wrapper={(Input, props, addFriendRequest, keyStr) => (
            <div className={'add-friend-modal__item-form'} key={keyStr}>
              {Input}
            </div>
          )}
        />
      );
    });
  }

  return (
    <CustomModal animation={['fade', 'scale', 'scale-bounce']}>
      <div className={'add-friend-modal'} ref={ref}>
        <div className='add-friend-modal__bg' onClick={close} />
        <div className='add-friend-modal__content'>
          <h2 className='add-friend-modal__title'>{isAdded ? t('addFriend.added') : t('addFriend.add')}</h2>
          <div className='add-friend-modal__block'>
            {isAdded ? (
              <div className={'add-friend-modal__form'}>
                <div className={'add-friend-modal__friend'}>
                  <div className={'add-friend-modal__friend-info'}>
                    <span className={'add-friend-modal__friend-name'}>{t(addFriend.friend.name)}</span>
                    <span className={'add-friend-modal__friend-level'}>{t(addFriend.friend.level)}</span>
                  </div>
                  <span className={'add-friend-modal__friend-points'}>{t(addFriend.friend.points)}</span>
                </div>
                <CustomButton
                  className={'add-friend-modal__button add-friend-modal__button_add'}
                  text={'addFriend.toAdd'}
                />
              </div>
            ) : (
              <Form
                className='add-friend-modal__form'
                onSubmit={onSubmitFriend}
                errors={errors}
                as={AddFriendForm}
                slots={slots}
                data={{ ...props, addFriendRequest: addFriendRequest }}
              />
            )}
            <CustomButton
              className={
                'custom-button custom-button_gray add-friend-modal__button add-friend-modal__button_close add-friend-modal_close'
              }
              text={t('other.cancel')}
              onClick={close}
            />
          </div>
        </div>
        {isPending && <AppLoader />}
      </div>
    </CustomModal>
  );
});
export default AddFriendModal;
AddFriendModal.propTypes = {};
